import React from 'react';

import TextPageHeader from 'Components/TextPageHeader';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const HomepageExplore = () => (
  <TextPageHeader
    title={<ConnectedFormattedMessage id="homepage_explore.title" />}
    description={
      <p className="TextPageHeader__paragraph">
        <ConnectedFormattedMessage id="homepage_explore.description" />
      </p>
    }
  />
);

export default HomepageExplore;
